export default __webpack_public_path__ + "static/media/wn_7_0.368efe45.webp";